
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRecordEventIec as ObiRecordEventIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-record-event-iec.js';
 
 
 

 
 export const ObiRecordEventIec = createComponent({
   react: React,
   tagName: 'obi-record-event-iec',
   elementClass: ObiRecordEventIecElement,
   events: {
     
   }
  });
 
 